import { Injectable } from '@angular/core';
import { UrlService } from 'src/app/shared/services/url/url.service';
import { environment } from 'src/environments/environment';
import { AppConfigService } from 'src/app/core/config/config.service';
import { CustomerUri, FinanceUri, CategoriesUri, ReportstUri } from 'src/app/core/config/config.model';

@Injectable({ providedIn: 'root' })

export class CustomersUriService {
  private baseUrl: string;
  private baseUrlV2: string;
  private categoriesUri: CategoriesUri;
  private customerUri: CustomerUri;
  private financeUri: FinanceUri;
  private reportsUri: ReportstUri;

  constructor
    (private urlService: UrlService, private apiConfig: AppConfigService) {

    this.baseUrl = environment.baseUrl;
    this.baseUrlV2 = environment.baseUrlTwo;
    this.customerUri = apiConfig.appConfig.customerUri;
    this.financeUri = apiConfig.appConfig.financeUri;
    this.categoriesUri = apiConfig.appConfig.categoriesUri;
    this.reportsUri = apiConfig.appConfig.reportsUri;
  }

  getCustomersUri() {
    return this.urlService.combineUri(this.baseUrl, this.customerUri.customers, this.customerUri.my_customers);
  }

  getUserPriceListUri() {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.assign_price, this.financeUri.assign_map)
  }

  getUserPriceListByPercentUri() {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.assign_percent, this.financeUri.assign_map)
  }

  getUserAssignPercentUri() {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.assign_percent, this.financeUri.my_percent_list)
  }

  getCustomerAssignPercentUri() {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.assign_percent, this.financeUri.my_customers_percent_list)
  }

  getDefaultPriceListUri() {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.default_prices)
  }

  getDefaultPriceListByPercentUri() {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.default_percents)
  }

  getDefaultPriceListInfoUri(id: number) {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.default_prices, id);
  }

  getDefaultPriceListByPercentInfoUri(id: number) {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.default_percents, id);
  }

  getDefaultPriceListDetailsUri(id: number) {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.default_prices, id, this.financeUri.items)
  }

  getDefaultPriceListDetailsByPercentUri(id: number) {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.default_percents, id, this.financeUri.items)

  }

  getAddDefaultPriceListInitUri(id: number) {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.default_prices, id, this.financeUri.bulk_insert)
  }

  getAddDefaultPercentListInitSingleUri(id: number) {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.default_percents, id, this.financeUri.items);
  }

  getDeleteDefaultPercentListInitSingleUri(listId: number, itemId: number) {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.default_percents, listId, this.financeUri.items, itemId);
  }

  getAddDefaultPriceListByPercentInitUri(id: number) {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.default_percents, id, this.financeUri.bulk_insert)
  }

  getCreateDefaultPriceListUri() {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.default_prices)
  }

  getDefaultPercentUserExceptionsUri(id) {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.default_percents, id, this.financeUri.user_exceptions);
  }

  getAvailableCurrenciesUri() {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.currency)
  }

  getCategoriesUri() {
    return this.urlService.combineUri(this.baseUrl, this.categoriesUri.cards, this.categoriesUri.categories)
  }

  getCustomerPriceUri() {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.assign_price)
  }

  getCustomerPercentUri() {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.assign_percent);
  }

  getRemoveCustomerPrice(id: number) {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.assign_price, id)
  }

  getRemoveCustomerPercent(id: number) {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.assign_percent, id)
  }

  getAssignDefaultPriceUri(defauldId: number) {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.default_prices, defauldId, this.financeUri.set_to_user);
  }

  getAssignDefaultListsUri() {
    return this.urlService.combineUri(this.baseUrl, this.customerUri.customers, this.customerUri.my_customers, this.customerUri.assign_lists)
  }

  getAssignDefaultPercentUri(defauldId: number) {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.default_percents, defauldId, this.financeUri.set_to_user);
  }
  getDeleteDefaultPriceListUri(id: number) {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.default_prices, id)
  }

  getCustomerFinanceSummaryUri() {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.user_finance_summary)
  }

  getUserWalletUri() {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.wallet)
  }
 
  getUserWalletArchiveUri() {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.wallet_archive)
  }

  getCascadeSellInvoiceItemsUri(id: number) {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.cascade_invoices, id, this.financeUri.items)
  }

  getCascadeSellInvoiceListUri() {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.cascade_invoices)
  }

  getCascadeSellInvoiceDetailsUri(id: number) {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.cascade_invoices, id)
  }

  getCascadeInvoiceRelatedOrdersUri(id: number) {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.cascade_invoices, id, this.financeUri.related_orders)
  }

  getCurrenciesUri() {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.currency);
  }

  getCurrencyUri(id: number) {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.currency, id);
  }

  getAddCreditUri() {
    return this.urlService.combineUri(this.baseUrlV2, this.financeUri.finance, this.financeUri.charge)
  }

  getRemoveCreditUri() {
    return this.urlService.combineUri(this.baseUrlV2, this.financeUri.finance, this.financeUri.decharge)
  }

  getCreatUserPaymentUri() {
    return this.urlService.combineUri(this.baseUrlV2, this.financeUri.finance, this.financeUri.payment)
  }

  getUpdateInvoiceItemPriceUri() {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance,
      this.financeUri.edit_order_price)
  }

  getUserWalletStatisticUri() {
    return this.urlService.combineUri(this.baseUrl, this.reportsUri.reports, this.reportsUri.panel, this.reportsUri.user_wallet_statistic)
  }

  getCreateCustomerByCodeUri() {
    return this.urlService.combineUri(this.baseUrl, this.customerUri.customers, this.customerUri.my_customers, this.customerUri.assign_by_code)
  }

  getCreateCustomerKYCUri() {
    return this.urlService.combineUri(this.baseUrl, this.customerUri.customers, this.customerUri.register_by_reseller);
  }

  getCustomersShowingPriceUri() {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.showing_prices)
  }

  getCustomerShowingPrice(id: number) {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.showing_prices, id)
  }

  getUserProfileByIdUri(id) {
    return this.urlService.combineUri(this.baseUrl, this.customerUri.customers, this.customerUri.my_customers, id)
  }

  getEnablePrintAccessUri(id) {
    return this.urlService.combineUri(this.baseUrl, this.customerUri.customers, this.customerUri.my_customers, id)
  }

  getImportDefaultFileUri(id) {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.default_prices, id, this.financeUri.bulk_insert_xls)
  }

  getImportDefaultFileByPercentUri(id) {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.default_percents, id, this.financeUri.bulk_insert_xls)
  }

  getCustomerProductListUri() {
    return this.urlService.combineUri(this.baseUrl, this.categoriesUri.cards, this.categoriesUri.product_lists)
  }

  getCustomerProductListMembersUri(id: number) {
    return this.urlService.combineUri(this.baseUrl, this.categoriesUri.cards, this.categoriesUri.product_lists, id, this.categoriesUri.members)
  }

  deleteCustomerProductListUri(id: number) {
    return this.urlService.combineUri(this.baseUrl, this.categoriesUri.cards, this.categoriesUri.product_lists, id);
  }

  deleteCustomerProductListByPercentUri(id: number) {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.default_percents, id);
  }

  getProductListActiveItemsUri(id: number) {
    return this.urlService.combineUri(this.baseUrl, this.categoriesUri.cards, this.categoriesUri.product_lists, id, this.categoriesUri.items)
  }

  getProductListItemsUri() {
    return this.urlService.combineUri(this.baseUrl, this.categoriesUri.cards, this.categoriesUri.products)
  }

  getProductListInfoUri(id: number) {
    return this.urlService.combineUri(this.baseUrl, this.categoriesUri.cards, this.categoriesUri.product_lists, id);
  }

  getCreateCustomerProductListUri() {
    return this.urlService.combineUri(this.baseUrl, this.categoriesUri.cards, this.categoriesUri.product_lists)
  }

  getPaymentMethodsUri() {
    return this.urlService.combineUri(this.baseUrlV2, this.financeUri.finance, this.financeUri.gateways)
  }

  getUserPaymentEmailsUri() {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.user_payment_email)
  }

  getUserPaymentEmailEditUri(id: number) {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.user_payment_email, id)
  }

  getProductSuggestionsUri() {
    return this.urlService.combineUri(this.baseUrl, this.categoriesUri.cards, this.categoriesUri.suggestions);
  }

  getAddDisplayPriceUri() {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.showing_prices)
  }

  getUserProfileUri() {
    return this.urlService.combineUri(this.baseUrl, this.customerUri.customers, this.customerUri.profile)
  }

  getImportDisplayPriceFileUri() {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.showing_prices, this.financeUri.bulk_insert_xls);
  }

  getSalesManagerListUri() {
    return this.urlService.combineUri(this.baseUrl, this.customerUri.customers, this.customerUri.sales_managers);
  }

  getSalesManagerDetailUri(id: number) {
    return this.urlService.combineUri(this.baseUrl, this.customerUri.customers, this.customerUri.sales_managers, id);
  }

  getSalesManagerActivateUri(id: number) {
    return this.urlService.combineUri(this.baseUrl, this.customerUri.customers, this.customerUri.sales_managers, id, this.customerUri.activate);
  }

  getSalesManagerDeactivateUri(id: number) {
    return this.urlService.combineUri(this.baseUrl, this.customerUri.customers, this.customerUri.sales_managers, id, this.customerUri.deactivate);
  }

  assignSalesManagerToCustomerUri(id: number) {
    return this.urlService.combineUri(this.baseUrl, this.customerUri.customers, this.customerUri.sales_managers, id, this.customerUri.set_to_user);
  }

  getAssignedCustomersSalesManagerUri(id: number) {
    return this.urlService.combineUri(this.baseUrl, this.customerUri.customers, this.customerUri.sales_managers, id, this.customerUri.customers)
  }

  getSalesManagerReportsUri() {
    return this.urlService.combineUri(this.baseUrl, this.reportsUri.reports, this.reportsUri.panel, this.customerUri.sales_managers, this.reportsUri.report)
  }

  getSalesManagerGeneralReportsUri() {
    return this.urlService.combineUri(this.baseUrl, this.reportsUri.reports, this.reportsUri.panel, this.customerUri.sales_managers, this.reportsUri.general_report)
  }

  getSalesManagerDetailReportsUri() {
    return this.urlService.combineUri(this.baseUrl, this.reportsUri.reports, this.reportsUri.panel, this.customerUri.sales_managers, this.reportsUri.detail_report)
  }

  userDefaultPaymentListUri() {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.user_default_payment_list)
  }

  userDefaultPaymentListActionsUri(id: number) {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.user_default_payment_list, id)
  }

  assignUserDefaultPaymentListUri(id: number) {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.user_default_payment_list, id, this.financeUri.assign);
  }

  getAssignedUsersDefaultPayment(id: number) {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.user_default_payment_list, id, this.financeUri.assigned_users);
  }

  getGatewaysUri() {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.user_default_payment_list, this.financeUri.gateways)
  }

  getMyMerchantsUri() {
    return this.urlService.combineUri(this.baseUrl, this.customerUri.customers, this.customerUri.my_merchants)
  }

  getSelectCurrentCompanyUri(company_id) {
    return this.urlService.combineUri(this.baseUrl, this.customerUri.customers, this.customerUri.select_company, company_id)
  }

  setAssignPercentException() {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.assign_percent, this.financeUri.set_exception)
  }

  getAssignPercentExcel() {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.assign_percent, this.financeUri.export);
  }

  getCustomerKycDetail(seller_id: number) {
    return this.urlService.combineUri(this.baseUrlV2, this.customerUri.customers, this.customerUri.kyc_customer_detail, seller_id)
  }

  defaultPriceListExcelBulkUpdate() {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.default_percents2, this.financeUri.bulk_update_products)
  }

  updateProductInMultiplePriceList() {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.default_percents2, this.financeUri.bulk_update)
  }

  getDefaultPriceListItemExport(id: any) {
   return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.default_percents, id, this.financeUri.items, this.financeUri.export)
  }

  exportPriceListItemExcelFile(id) {
    return this.urlService.combineUri(this.baseUrl, this.financeUri.finance, this.financeUri.default_percents, id, this.financeUri.items, this.financeUri.export);
  }

  exportCustomerDefaultAssignItems(id) {
    return this.urlService.combineUri(this.baseUrlV2, this.financeUri.finance, this.financeUri.default_assign_percent, id, this.financeUri.items, this.financeUri.customer_export);
  }

  exportDefaultAssignPriceItems(id) {
    return this.urlService.combineUri(this.baseUrlV2, this.financeUri.finance, this.financeUri.default_assign_percent, id, this.financeUri.items, this.financeUri.export);
  }

  getDefaultAssignPriceListItemsUri(id: number) {
    return this.urlService.combineUri(this.baseUrlV2, this.financeUri.finance, this.financeUri.default_assign_percent, id, this.financeUri.items);
  }
}
